import { IntegrationTypeCodes } from '@/store/types'

export default {
  computed: {
    hasXeroIntegration() {
      return this.userHasAccountIntegration(IntegrationTypeCodes.xero)
    },
    hasMyobIntegration() {
      return this.userHasAccountIntegration(IntegrationTypeCodes.myob)
    },
  },
  methods: {
    // Check if the logged in user has an integration enabled for the account
    userHasAccountIntegration(integrationCode) {
      try {
        if(this.$store.state.profile.activeIntegrations[integrationCode] == undefined)
          return false
        return true
      } catch {
        return false
      }
    },

    
  }
}
